import React from "react";
import PropTypes from "prop-types";
import BackgroundImage from "wonderbly-components/lib/BackgroundImage";

import "./FullWidthImage.scss";

const FullWidthImage = (props) => (
  <section className="FullWidthImage" id={props.id}>
    <BackgroundImage image={props.image} />
  </section>
);

FullWidthImage.propTypes = {
  id: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default FullWidthImage;
